import axios from 'axios'

const service = axios.create({
    //FIXME 修改路径
    baseURL: 'http://47.112.189.89:9080/admin',
    timeout: 10000
})

export default service


// WEBPACK FOOTER //
// ./src/api/index.js